import React from 'react';
import DynamicPage from '../../dynamicPage';
import { fetchAllPages, fetchPageContent } from '../../squidexClient';
import ErrorPage from './error/ErrorPage';

let pages = [];

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */

// The top-level (parent) route
const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    // {
    //   path: '/about-us',
    //   load: () =>
    //     import(/* webpackChunkName: 'our-story' */ './about-us/our-story'),
    // },
    // {
    //   path: '/about-us/our-story',
    //   load: () =>
    //     import(/* webpackChunkName: 'our-story' */ './about-us/our-story'),
    // },
    // {
    //   path: '/about-us/team',
    //   load: () =>
    //     import(/* webpackChunkName: 'meet-the-team' */ './about-us/meet-the-team'),
    // },
    // {
    //   path: '/about-us/media',
    //   load: () =>
    //     import(/* webpackChunkName: 'in-the-media' */ './about-us/media'),
    // },
    {
      path: '/atp',
      load: () =>
        import(/* webpackChunkName: 'enquiry-form' */ './enquiry-form'),
    },
    {
      path: '/ace',
      load: () =>
        import(/* webpackChunkName: 'enquiry-form' */ './enquiry-form'),
    },
    {
      path: '/keep',
      load: () =>
        import(/* webpackChunkName: 'enquiry-form' */ './enquiry-form'),
    },
    {
      path: '/account-settings',
      children: [
        {
          path: '',
          load: () =>
            import(/* webpackChunkName: 'account-settings' */ './account-settings'),
        },
        {
          path: '/location',
          load: () =>
            import(/* webpackChunkName: 'account-settings-location' */ './account-settings/location-settings'),
        },
        {
          path: '/edit-profile',
          load: () =>
            import(/* webpackChunkName: 'account-settings-edit-profile' */ './account-settings/edit-profile'),
        },
        {
          path: '/contact',
          load: () =>
            import(/* webpackChunkName: 'account-settings-contact' */ './account-settings/contact'),
        },
        {
          path: '/password',
          load: () =>
            import(/* webpackChunkName: 'account-settings-password' */ './account-settings/password-update'),
        },
        {
          path: '/tutor-payouts',
          load: () =>
            import(/* webpackChunkName: 'account-settings-payouts' */ './account-settings/tutor-payouts'),
        },
        {
          path: '/tutor-payouts/stripe-connect',
          load: () =>
            import(/* webpackChunkName: 'account-settings-payouts-stripe-connect' */ './account-settings/tutor-payouts/stripe-connect-manage'),
        },
        {
          path: '/tutor-payouts/venmo',
          load: () =>
            import(/* webpackChunkName: 'account-settings-payouts-venmo' */ './account-settings/tutor-payouts/venmo-manage'),
        },
        {
          path: '/tutor-payouts/paypal',
          load: () =>
            import(/* webpackChunkName: 'account-settings-payouts-pay-pal' */ './account-settings/tutor-payouts/pay-pal-manage'),
        },
        {
          path: '/payment',
          load: () =>
            import(/* webpackChunkName: 'account-settings-payment' */ './account-settings/payment'),
        },
        {
          path: '/notifications',
          load: () =>
            import(/* webpackChunkName: 'account-settings-notifications' */ './account-settings/notifications'),
        },
        {
          path: '/visibility',
          load: () =>
            import(/* webpackChunkName: 'account-settings-visibility' */ './account-settings/visibility'),
        },
        {
          path: '/zoom',
          load: () =>
            import(/* webpackChunkName: 'zoom-settings' */ './account-settings/zoom-settings/zoom-settings'),
        },
        {
          path: '/zoom/success',
          load: () =>
            import(/* webpackChunkName: 'zoom-settings-success' */ './account-settings/zoom-settings/integration-success'),
        },
        {
          path: '/school-and-courses',
          load: () =>
            import(/* webpackChunkName: 'account-settings-school-and-courses' */ './account-settings/school-and-courses'),
        },
        {
          path: '/school-and-courses/add-courses',
          load: () =>
            import(/* webpackChunkName: 'account-settings-school-and-courses-add-courses' */ './account-settings/school-and-courses/add-courses'),
        },
      ],
    },
    {
      path: '/admin',
      children: [
        {
          path: '',
          load: () => import(/* webpackChunkName: 'admin' */ './admin'),
        },
        {
          path: '/onboard',
          load: () =>
            import(/* webpackChunkName: 'admin-tutor-onboarding' */ './admin/onboard'),
        },
        {
          path: '/search',
          load: () =>
            import(/* webpackChunkName: 'admin-active-tutor-search' */ './admin/search'),
        },
      ],
    },
    {
      path: '/apply',
      children: [
        // {
        //   path: '',
        //   load: () => import(/* webpackChunkName: 'apply' */ './apply'),
        // },
        {
          path: '/referral',
          load: () =>
            import(/* webpackChunkName: 'referral-apply' */ './apply/referral'),
        },
        {
          path: '/core-subjects',
          load: () =>
            import(/* webpackChunkName: 'coreSubjects' */ './apply/coreSubjects'),
        },
        {
          path: '/education-level',
          load: () =>
            import(/* webpackChunkName: 'educationLevel' */ './apply/educationLevel'),
        },
        {
          path: '/location',
          load: () =>
            import(/* webpackChunkName: 'location' */ './apply/location'),
        },
        {
          path: '/school-info',
          load: () =>
            import(/* webpackChunkName: 'schoolInfo' */ './apply/schoolInfo'),
        },
        {
          path: '/high-school-courses',
          load: () =>
            import(/* webpackChunkName: 'highSchoolCourses' */ './apply/highSchoolCourseSelect'),
        },
        {
          path: '/college-courses',
          load: () =>
            import(/* webpackChunkName: 'collegeCourses' */ './apply/collegeCourseSelect'),
        },
        {
          path: '/tutoring-preferences',
          load: () =>
            import(/* webpackChunkName: 'tutoringPreferences' */ './apply/tutoringPreferences'),
        },
        {
          path: '/availability',
          load: () =>
            import(/* webpackChunkName: 'availability' */ './apply/availability'),
        },
        {
          path: '/about',
          load: () =>
            import(/* webpackChunkName: 'aboutYourself' */ './apply/aboutYourself'),
        },
      ],
    },
    // {
    //   path: '/contact',
    //   load: () => import(/* webpackChunkName: 'contact' */ './contact'),
    // },
    // {
    //   path: '/support',
    //   load: () => import(/* webpackChunkName: 'support' */ './support'),
    // },
    {
      path: '/conversation/:conversationId',
      load: () =>
        import(/* webpackChunkName: 'conversation' */ './conversation'),
    },
    {
      path: '/dashboard',
      children: [
        {
          path: '/edit-profile/add-high-school-classes',
          load: () =>
            import(/* webpackChunkName: 'editHighSchoolClasses' */ './editHighSchoolClasses'),
        },
        {
          path: '/edit-profile/add-college-classes',
          load: () =>
            import(/* webpackChunkName: 'editCollegeClasses' */ './editCollegeClasses'),
        },
        {
          path: '', // optional, matches both "/dashboard" and "/dashboard/"
          load: () => import(/* webpackChunkName: 'sessions' */ './sessions'),
        },
        {
          path: '/:mainTab',
          load: () => import(/* webpackChunkName: 'dashboard' */ './dashboard'),
        },
        {
          path: '/:mainTab/:subTab',
          load: () => import(/* webpackChunkName: 'dashboard' */ './dashboard'),
        },
      ],
    },
    {
      path: '/edit-profile',
      load: () =>
        import(/* webpackChunkName: 'edit-profile' */ './edit-profile'),
    },
    {
      path: '/edit-profile/add-courses',
      load: () => import(/* webpackChunkName: 'add-courses' */ './add-courses'),
    },
    // {
    //   path: '/faq',
    //   load: () => import(/* webpackChunkName: 'faq' */ './faq'),
    // },
    // {
    //   path: '/find-a-tutor',
    //   load: () =>
    //     import(/* webpackChunkName: 'find-a-tutor' */ './find-a-tutor'),
    // },
    {
      path: '/find-a-tutor/name',
      load: () =>
        import(/* webpackChunkName: 'find-a-tutor-by-name' */ './find-a-tutor-by-name'),
    },
    {
      path: '/forgot-password',
      load: () =>
        import(/* webpackChunkName: 'forgot-password' */ './forgot-password'),
    },
    {
      path: '/school/homestead-hs',
      load: () =>
        import(/* webpackChunkName: 'landing-homestead-hs' */ './landing-homestead-hs'),
    },
    {
      path: '/inbox',
      load: () => import(/* webpackChunkName: 'inbox' */ './inbox'),
    },
    {
      path: '/institution-search',
      load: () =>
        import(/* webpackChunkName: 'institution-search' */ './institution-search'),
    },
    {
      path: '/login',
      load: () => import(/* webpackChunkName: 'login' */ './login'),
    },
    // {
    //   path: '/pricing',
    //   load: () => import(/* webpackChunkName: 'pricing' */ './pricing'),
    // },
    {
      path: '/privacy',
      load: () => import(/* webpackChunkName: 'privacy' */ './privacy'),
    },
    {
      path: '/refer-friend',
      load: () =>
        import(/* webpackChunkName: 'refer-friend' */ './refer-friend'),
    },
    {
      path: '/tutor-tools',
      children: [
        {
          path: '',
          load: () =>
            import(/* webpackChunkName: 'tutor-tools' */ './tutor-tools'),
        },
        {
          path: '/find-tutoring',
          children: [
            {
              path: '',
              load: () =>
                import(/* webpackChunkName: 'find-tutoring' */ './tutor-tools/find-tutoring'),
            },
            {
              path: '/nextdoor',
              load: () =>
                import(/* webpackChunkName: 'nextdoor' */ './tutor-tools/find-tutoring/nextdoor'),
            },
            {
              path: '/email-teachers',
              load: () =>
                import(/* webpackChunkName: 'email-teachers' */ './tutor-tools/find-tutoring/email-teachers'),
            },
            {
              path: '/shortcuts',
              load: () =>
                import(/* webpackChunkName: 'shortcuts' */ './tutor-tools/find-tutoring/shortcuts'),
            },
          ],
        },
        {
          path: '/online-tutoring-tips',
          children: [
            {
              path: '',
              load: () =>
                import(/* webpackChunkName: 'online-tutoring-tips' */ './tutor-tools/online-tutoring-tips'),
            },
            {
              path: '/lessonspace',
              load: () =>
                import(/* webpackChunkName: 'lessonspace' */ './tutor-tools/online-tutoring-tips/lessonspace'),
            },
          ],
        },
      ],
    },
    {
      path: '/tutor-refer-tutor',
      load: () =>
        import(/* webpackChunkName: 'tutor-refer-tutor' */ './tutor-refer-tutor'),
    },
    {
      path: '/tutor-refer-client',
      load: () =>
        import(/* webpackChunkName: 'tutor-refer-client' */ './tutor-refer-client'),
    },
    {
      path: '/referral',
      children: [
        {
          path: '/:subPath',
          load: () => import(/* webpackChunkName: 'referral' */ './referral'),
        },
      ],
    },
    {
      path: '/request-a-tutor',
      load: () =>
        import(/* webpackChunkName: 'request-a-tutor' */ './request-a-tutor'),
    },
    {
      path: '/reset-password/:token',
      load: () =>
        import(/* webpackChunkName: 'reset-password' */ './reset-password'),
    },
    {
      path: '/su/h/:ticketId',
      load: () =>
        import(/* webpackChunkName: 'personalized-onboarding' */ './personalized-onboarding'),
    },
    {
      path: '/su/invalid',
      load: () =>
        import(/* webpackChunkName: 'invalid' */ './personalized-onboarding/invalid'),
    },
    {
      path: '/student-become-tutor',
      children: [
        {
          path: '',
          load: () =>
            import(/* webpackChunkName: 'student-become-tutor' */ './apply/student-become-tutor'),
        },
        {
          path: '/core-info',
          load: () =>
            import(/* webpackChunkName: 'apply-core-info' */ './apply/coreInfo'),
        },
        {
          path: '/core-subjects',
          load: () =>
            import(/* webpackChunkName: 'coreSubjects' */ './apply/coreSubjects'),
        },
        {
          path: '/education-level',
          load: () =>
            import(/* webpackChunkName: 'educationLevel' */ './apply/educationLevel'),
        },
        {
          path: '/location',
          load: () =>
            import(/* webpackChunkName: 'location' */ './apply/location'),
        },
        {
          path: '/school-info',
          load: () =>
            import(/* webpackChunkName: 'schoolInfo' */ './apply/schoolInfo'),
        },
        {
          path: '/high-school-courses',
          load: () =>
            import(/* webpackChunkName: 'highSchoolCourses' */ './apply/highSchoolCourseSelect'),
        },
        {
          path: '/college-courses',
          load: () =>
            import(/* webpackChunkName: 'collegeCourses' */ './apply/collegeCourseSelect'),
        },
        {
          path: '/tutoring-preferences',
          load: () =>
            import(/* webpackChunkName: 'tutoringPreferences' */ './apply/tutoringPreferences'),
        },
        {
          path: '/availability',
          load: () =>
            import(/* webpackChunkName: 'availability' */ './apply/availability'),
        },
        {
          path: '/about',
          load: () =>
            import(/* webpackChunkName: 'aboutYourself' */ './apply/aboutYourself'),
        },
      ],
    },
    {
      path: '/sessions',
      children: [
        {
          path: '', // optional, matches both "/sessions" and "/sessions/"
          load: () => import(/* webpackChunkName: 'sessions' */ './sessions'),
        },
        {
          path: '/:subPath',
          load: () => import(/* webpackChunkName: 'sessions' */ './sessions'),
        },
      ],
    },
    {
      path: '/signup',
      children: [
        {
          path: '', // optional, matches both "/signup" and "/signup/"
          load: () => import(/* webpackChunkName: 'signup' */ './signup'),
        },
        {
          path: '/profileType',
          load: () =>
            import(/* webpackChunkName: 'signupProfileType' */ './signupProfileType'),
        },
        {
          path: '/contactInfo',
          load: () =>
            import(/* webpackChunkName: 'signupContactInfo' */ './signupContactInfo'),
        },
        // {
        //   path: '/waiver',
        //   load: () =>
        //     import(/* webpackChunkName: 'sign-up-waiver' */ './signup-waiver'),
        // },
      ],
    },
    // {
    //   path: '/schools',
    //   load: () => import(/* webpackChunkName: 'schools' */ './schools'),
    // },
    {
      path: '/schools/blog/1',
      load: () => import(/* webpackChunkName: 'post-1' */ './schools/blog/1'),
    },
    {
      path: '/schools/blog/2',
      load: () => import(/* webpackChunkName: 'post-2' */ './schools/blog/2'),
    },
    {
      path: '/schools/blog/3',
      load: () => import(/* webpackChunkName: 'post-3' */ './schools/blog/3'),
    },
    {
      path: '/schools/blog/4',
      load: () => import(/* webpackChunkName: 'post-4' */ './schools/blog/4'),
    },
    {
      path: '/schools/blog/5',
      load: () => import(/* webpackChunkName: 'post-5' */ './schools/blog/5'),
    },
    // {
    //   path: '/marketplace',
    //   load: () => import(/* webpackChunkName: 'marketplace' */ './marketplace'),
    // },
    {
      path: '/terms',
      load: () => import(/* webpackChunkName: 'terms' */ './terms'),
    },
    {
      path: '/tutor/:profilePageId',
      load: () =>
        import(/* webpackChunkName: 'tutorProfilePage' */ './tutorProfilePage'),
    },
    {
      path: '/u/:profileId',
      load: () => import(/* webpackChunkName: 'profilePage' */ './profilePage'),
    },
    {
      path: '/c/:profileId',
      load: () =>
        import(/* webpackChunkName: 'clientReferralPage' */ './clientReferralPage'),
    },
    {
      path: '/trt/:profileId',
      load: () =>
        import(/* webpackChunkName: 'tutor-refer-tutor-landing' */ './tutor-refer-tutor-landing'),
    },
    {
      path: '/trc/:profileId',
      load: () =>
        import(/* webpackChunkName: 'tutor-refer-client-landing' */ './tutor-refer-client-landing'),
    },
    {
      path: '/school/:schoolName/:schoolCity/:schoolState',
      load: () =>
        import(/* webpackChunkName: 'schoolLanding' */ './schoolLanding'),
    },
    {
      path: '/search',
      load: () => import(/* webpackChunkName: 'search' */ './search'),
    },
    {
      path: '/ss/:pairId',
      load: () =>
        import(/* webpackChunkName: 'session-summaries' */ './session-summaries'),
    },
    {
      path: '/sccvl/:profileId',
      load: () =>
        import(/* webpackChunkName: 'sportsClubLandingPage' */ './sportsClubLandingPage'),
    },
    {
      path: '/welcome',
      children: [
        {
          path: '',
          load: () =>
            import(/* webpackChunkName: 'welcome-client' */ './welcome/welcome-client'),
        },
        {
          path: '/payment',
          load: () =>
            import(/* webpackChunkName: 'welcome-payment' */ './welcome/welcome-payment'),
        },
        {
          path: '/request-a-tutor',
          load: () =>
            import(/* webpackChunkName: 'welcome-request-a-tutor' */ './welcome/welcome-request-a-tutor'),
        },
        {
          path: '/verify-account',
          load: () =>
            import(/* webpackChunkName: 'welcome-verify-account' */ './welcome/welcome-verify-account'),
        },
        {
          path: '/location',
          load: () =>
            import(/* webpackChunkName: 'welcomeLocation' */ './welcomeLocation'),
        },
      ],
    },
    {
      path: '/w/h',
      children: [
        {
          path: '',
          load: () =>
            import(/* webpackChunkName: 'personalized-onboarding-welcome' */ './personalized-onboarding/welcome'),
        },
        {
          path: '/payment',
          load: () =>
            import(/* webpackChunkName: 'personalized-onboarding-payment' */ './personalized-onboarding/payment'),
        },
        {
          path: '/complete',
          load: () =>
            import(/* webpackChunkName: 'personalized-onboarding-complete' */ './personalized-onboarding/complete'),
        },
      ],
    },
    {
      path: '(/not-found)',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
    {
      path: '/zoom-documentation',
      load: () =>
        import(/* webpackChunkName: 'zoom-documentation' */ './zoom-documentation'),
    },
    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    // {
    //   path: '(.*)',
    //   load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    // },
    {
      path: '(.*)',
      async action({ path }) {
        if (pages.length === 0) {
          pages = await fetchAllPages();
        }

        // const slug = path.slice(1);
        const slug = path === '/' ? 'home' : path.slice(1);
        let isLoading = true;
        let pageData;

        try {
          pageData = await fetchPageContent(slug);
        } catch (error) {
          console.error('Error fetching page content:', error);
        } finally {
          isLoading = false;
        }

        if (pageData && pageData.flatData) {
          return {
            title:
              pageData.flatData.title || 'Tutorfly - Powered by Kip McGrath',
            description: pageData.flatData.metaDescription || '',
            component: (
              <DynamicPage pageData={pageData.flatData} isLoading={isLoading} />
            ),
          };
        }

        return {
          title: 'Tutorfly - Powered by Kip McGrath.',
          description:
            'Find expert tutors and personalized learning experiences.',
          component: (
            <DynamicPage
              error={new Error('Page not found')}
              isLoading={isLoading}
            />
          ),
        };
      },
    },
  ],

  async action({ next }) {
    try {
      const route = await next();

      // For dynamic routes (Squidex pages)
      if (route.component && route.component.type === DynamicPage) {
        const { pageData } = route.component.props;
        if (pageData) {
          route.title = pageData.title || 'Tutorfly - Powered by Kip McGrath';
          route.description = pageData.metaDescription || '';
        }
        // Remove the else block that sets "Page Not Found"
      }

      // For standard routes
      if (!route.title && route.load) {
        const module = await route.load();
        route.title = module.title || 'Tutorfly - Powered by Kip McGrath';
        route.description = module.description || '';
      }

      // Fallback
      route.title = route.title || 'Tutorfly - Powered by Kip McGrath';
      route.description = route.description || '';

      return route;
    } catch (error) {
      console.error('Route action error:', error);
      return {
        title: 'Error',
        description: 'An error occurred while loading the page.',
        component: <ErrorPage error={error} />,
      };
    }
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error/ErrorPage').default,
  });
}

export default routes;
